import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { action } from './action';
import { background } from './background';
import { border } from './border';
import { blue, green, grey, INVALID_FALLBACK_COLOR, orange, red } from './colors';
import { ChronosphereColor } from './colors/types';
import { error } from './error';
import { events } from './events';
import { greyOption } from './grey';
import { illustration } from './illustration';
import { info } from './info';
import { interactive } from './interactive';
import { primary } from './primary';
import { secondary } from './secondary';
import { status } from './status';
import { success } from './success';
import { syntaxHighlighting } from './syntax-highlighting';
import { text } from './text';
import { threshold } from './threshold';
import { warning } from './warning';

const fillerColor: ChronosphereColor = {
  50: INVALID_FALLBACK_COLOR,
  100: INVALID_FALLBACK_COLOR,
  150: INVALID_FALLBACK_COLOR,
  200: INVALID_FALLBACK_COLOR,
  300: INVALID_FALLBACK_COLOR,
  400: INVALID_FALLBACK_COLOR,
  500: INVALID_FALLBACK_COLOR,
  600: INVALID_FALLBACK_COLOR,
  700: INVALID_FALLBACK_COLOR,
  800: INVALID_FALLBACK_COLOR,
  850: INVALID_FALLBACK_COLOR,
  900: INVALID_FALLBACK_COLOR,
  950: INVALID_FALLBACK_COLOR,
};

/**
 * Returns the MUI PaletteOptions for the given mode.
 */
export function getPaletteOptions(mode: PaletteMode, opts: GetThemeOptions): PaletteOptions {
  // Palette options should be split out into their own files with functions
  // for creating the option values based on light/dark mode
  return {
    mode,
    primary: primary(mode, opts),
    secondary: secondary(mode, opts),
    grey: opts.panwRebrandStubYear ? fillerColor : greyOption(mode, opts),
    background: background(mode, opts),
    action: action(mode, opts),
    text: text(mode, opts),
    error: error(mode, opts),
    warning: warning(mode, opts),
    info: info(mode, opts),
    success: success(mode, opts),
    interactive: interactive(mode, opts),
    threshold: threshold(mode, opts),

    // Custom colors
    designSystem: opts.panwRebrandStubYear
      ? {
          blue: fillerColor,
          green: fillerColor,
          grey: fillerColor,
          orange: fillerColor,
          red: fillerColor,
        }
      : {
          blue,
          green,
          grey,
          orange,
          red,
        },
    status: status(mode, opts),
    border: border(mode, opts),
    syntaxHighlighting: syntaxHighlighting(mode, opts),
    illustration: illustration(mode, opts),
    events: events(mode, opts),

    // A contrast threshold of 4.5:1 is required to meet AA
    // https://mui.com/material-ui/customization/palette/#accessibility
    contrastThreshold: 4.5,
  };
}
